// Tulane University's undergraduate majors (#2652, round 2). Read on
// 2026-10-01 from the official 2026-2027 University Catalog's Programs page
// (catalog.tulane.edu/programs/), which tags each program by type (Major,
// Minor, Certificate, Graduate Program), level and school. Every program
// tagged "Major" is kept, grouped by its school; minors, certificates and
// graduate programs are left out. The degree is taken from the program's
// title where the list names it ("Accounting Major, BSM", "Dance, BFA");
// many titles name no degree ("History Major"), so degree is null there
// rather than guessed. Formatting only: the trailing word "Major" and the
// ", BA"-style suffix are dropped from names, and "Political Science/
// International Relations" loses the stray space after the slash. Coordinate
// majors (taken alongside another major) carry a note. Nursing is tagged for
// both the School of Medicine and the School of Professional Advancement and
// sits under the School of Medicine. School of Professional Advancement
// majors that the catalog also tags for Newcomb-Tulane College (the
// undergraduate college first-year applicants enter) carry a note.
const majors = {
    "slug": "tulane-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Tulane's official 2026-2027 University Catalog, grouped by the school that offers it. The degree is shown where the catalog's program list names it. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "A. B. Freeman School of Business",
            "source": {
                "label": "Tulane University Catalog 2026-2027, Programs",
                "url": "https://catalog.tulane.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSM"
                },
                {
                    "name": "Finance",
                    "degree": "BSM"
                },
                {
                    "name": "Legal Studies in Business",
                    "degree": "BSM"
                },
                {
                    "name": "Management",
                    "degree": "BSM"
                },
                {
                    "name": "Marketing",
                    "degree": "BSM"
                }
            ]
        },
        {
            "name": "School of Architecture and Built Environment",
            "source": {
                "label": "Tulane University Catalog 2026-2027, Programs",
                "url": "https://catalog.tulane.edu/programs/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch"
                },
                {
                    "name": "Architecture",
                    "degree": "BSA"
                },
                {
                    "name": "Design",
                    "degree": "BA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Urbanism",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Liberal Arts",
            "source": {
                "label": "Tulane University Catalog 2026-2027, Programs",
                "url": "https://catalog.tulane.edu/programs/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Cinema Studies",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Studies",
                    "degree": null,
                    "note": "Coordinate major"
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Digital Media Practices",
                    "degree": null,
                    "note": "Coordinate major"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Latin American Studies",
                    "degree": null
                },
                {
                    "name": "Latin",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Medieval and Early Modern Studies",
                    "degree": null
                },
                {
                    "name": "Middle East & North African Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BFA"
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy with Concentration in Language, Mind, and Knowledge",
                    "degree": null
                },
                {
                    "name": "Philosophy with Concentration in Law, Morality, and Society",
                    "degree": null
                },
                {
                    "name": "Political Economy with Concentration in Economics and Public Policy",
                    "degree": null
                },
                {
                    "name": "Political Economy with Concentration in International Perspectives",
                    "degree": null
                },
                {
                    "name": "Political Economy with Concentration in Law, Economics, and Policy",
                    "degree": null
                },
                {
                    "name": "Political Economy with Concentration in Moral and Historical Perspectives",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Political Science/International Development",
                    "degree": null
                },
                {
                    "name": "Political Science/International Relations",
                    "degree": null
                },
                {
                    "name": "Portuguese",
                    "degree": null,
                    "note": "Coordinate major"
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Social Policy and Practice",
                    "degree": null,
                    "note": "Coordinate major"
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Design",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Science and Engineering",
            "source": {
                "label": "Tulane University Catalog 2026-2027, Programs",
                "url": "https://catalog.tulane.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biological Chemistry",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Cell and Molecular Biology",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Civil Engineering - Water and Environment",
                    "degree": null
                },
                {
                    "name": "Computer Science Interdisciplinary",
                    "degree": null,
                    "note": "Coordinate major"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": null
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": null
                },
                {
                    "name": "Engineering Physics",
                    "degree": null
                },
                {
                    "name": "Environmental Biology",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                }
            ]
        },
        {
            "name": "Celia Scott Weatherhead School of Public Health and Tropical Medicine",
            "source": {
                "label": "Tulane University Catalog 2026-2027, Programs",
                "url": "https://catalog.tulane.edu/programs/"
            },
            "majors": [
                {
                    "name": "Health Policy and Management",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BSPH"
                }
            ]
        },
        {
            "name": "School of Medicine",
            "source": {
                "label": "Tulane University Catalog 2026-2027, Programs",
                "url": "https://catalog.tulane.edu/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "School of Professional Advancement",
            "source": {
                "label": "Tulane University Catalog 2026-2027, Programs",
                "url": "https://catalog.tulane.edu/programs/"
            },
            "majors": [
                {
                    "name": "Digital Design",
                    "degree": "BA"
                },
                {
                    "name": "Digital Media & Marketing Communications",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS",
                    "note": "Also in Newcomb-Tulane College"
                },
                {
                    "name": "Health and Wellness",
                    "degree": "BA",
                    "note": "Also in Newcomb-Tulane College"
                },
                {
                    "name": "Homeland Security",
                    "degree": "BA",
                    "note": "Also in Newcomb-Tulane College"
                },
                {
                    "name": "Human Resources",
                    "degree": "BA"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS",
                    "note": "Also in Newcomb-Tulane College"
                },
                {
                    "name": "Interdisciplinary Studies with Concentrations",
                    "degree": "BIS"
                },
                {
                    "name": "Organizational Behavior and Management Studies",
                    "degree": "BS"
                },
                {
                    "name": "Paralegal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Paralegal Studies",
                    "degree": "BIS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Secondary Education (Grades 6-12)",
                    "degree": null,
                    "note": "Coordinate major; Also in Newcomb-Tulane College"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BA"
                },
                {
                    "name": "Social Sciences",
                    "degree": "BA"
                }
            ],
            "note": "The catalog lists these majors under the School of Professional Advancement. Those marked \"Also in Newcomb-Tulane College\" are tagged for both."
        }
    ]
};

export default majors;
